/**
 * Format ISK amount. Icelandic króna has no decimal places.
 * Example: 9500 → "9.500 kr."
 */
export function formatIsk(amount) {
    return `${amount.toLocaleString('is-IS')} kr.`;
}
/**
 * Parse ISK string back to number.
 */
export function parseIsk(formatted) {
    return parseInt(formatted.replace(/[^\d]/g, ''), 10);
}
//# sourceMappingURL=currency.js.map